import { useState } from 'react';

export const useDialog = (): {
  isDialogOpen: boolean;
  isDialogLocked: boolean;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
  handleLockDialog: () => void;
  handleUnlockDialog: () => void;
} => {
  const [isDialogOpen, setOpenDeleteDialog] = useState<boolean>(false);
  const [isDialogLocked, setIsLocked] = useState<boolean>(false);

  const handleOpenDialog = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleLockDialog = () => {
    setIsLocked(true);
  };

  const handleUnlockDialog = () => {
    setIsLocked(false);
  };

  return { isDialogOpen, isDialogLocked, handleOpenDialog, handleCloseDialog, handleLockDialog, handleUnlockDialog };
};
